import React from 'react';

import {
  Box,
  Heading,
  SimpleGrid,
  FormControl,
  FormLabel,
  Input,
  IconButton,
  Icon,
} from '@chakra-ui/react';

import { BsTrash } from 'react-icons/bs';
import { useColors } from './colors';

const WeightShipping = ({ weights, onWeightChange, onRemoveWeight }) => {
  const { backgroundCardColor, textColor } = useColors();

  return (
    <Box
      p={6}
      bg={backgroundCardColor}
      borderRadius="lg"
      boxShadow="sm"
      minH="300px"
      h="100%"
      display="flex"
      flexDirection="column"
    >
      <Heading size="lg" mb={6} color={textColor}>
        Weight Shipping
      </Heading>
      <Box flex="1" minH="0" overflowY="auto">
        {weights.map((weight, index) => (
          <SimpleGrid columns={12} spacing={4} mb={4} key={index}>
            <FormControl gridColumn="span 3">
              <FormLabel fontSize="sm">Min. Weight</FormLabel>
              <Input
                value={weight.min}
                onChange={(e) => onWeightChange(index, 'min', e.target.value)}
                color={textColor}
              />
            </FormControl>
            <FormControl gridColumn="span 3">
              <FormLabel fontSize="sm">Max. Weight</FormLabel>
              <Input
                value={weight.max}
                onChange={(e) => onWeightChange(index, 'max', e.target.value)}
                color={textColor}
              />
            </FormControl>
            <FormControl gridColumn="span 3">
              <FormLabel fontSize="sm">Cost</FormLabel>
              <Input
                value={weight.cost}
                onChange={(e) => onWeightChange(index, 'cost', e.target.value)}
                color={textColor}
              />
            </FormControl>
            <Box gridColumn="span 3" pt={8}>
              <IconButton
                icon={<Icon as={BsTrash} />}
                colorScheme="red"
                variant="ghost"
                onClick={() => onRemoveWeight(index)}
                aria-label="Remove weight"
              />
            </Box>
          </SimpleGrid>
        ))}
      </Box>
    </Box>
  );
};

export default WeightShipping;
